import { apiClient } from './apiClient';
import type {
  User,
  AuthResponse,
  LoginCredentials,
  ApiResponse,
} from '../types';

export const authService = {
  // Login
  async login(credentials: LoginCredentials): Promise<ApiResponse<AuthResponse>> {
    const response = await apiClient.post<ApiResponse<AuthResponse>>('/auth/login', credentials);
    
    if (response.success && response.data) {
      apiClient.setTokens(response.data.accessToken, response.data.refreshToken);
    }
    
    return response;
  },

  // Logout
  async logout(): Promise<void> {
    try {
      await apiClient.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      apiClient.clearTokens();
    }
  },

  // Get current user profile
  async getCurrentUser(): Promise<ApiResponse<User>> {
    return apiClient.get<ApiResponse<User>>('/auth/me');
  },

  // Change password
  async changePassword(currentPassword: string, newPassword: string): Promise<ApiResponse<void>> {
    return apiClient.post<ApiResponse<void>>('/auth/change-password', {
      currentPassword,
      newPassword,
    });
  },

  // Check if user is authenticated
  async isAuthenticated(): Promise<boolean> {
    return apiClient.isAuthenticated();
  },

  // Get current user ID
  getCurrentUserId(): string | null {
    return apiClient.getCurrentUserId();
  },

  // Get current user role
  getUserRole(): string | null {
    return apiClient.getUserRole();
  },
};
